import React, { useState, useEffect, useRef } from "react";
import { BsInfoCircleFill } from "react-icons/bs";
import { Overlay } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import "../assets/css/quiz.css";
import { Formik } from "formik";
import * as yup from "yup";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import useQuizQuery from "../hooks/QuizQuery";
import axios from "axios";

const Quiz = () => {
  const { wpPage } = useQuizQuery();
  const [show, setShow] = useState({
    qi: null,
    ai: null,
    show: false,
  });

  const [showResult, setResultShow] = useState(false);
  const [ResultData, setResultData] = useState([]);
  const {
    quiz: { quizQuesitionAndAnswer },
    quizResult: { quizResult },
    disclaimer: { disclaimer },
  } = wpPage;

  const [quizData, setQuiz] = useState([]);
  useEffect(() => {
    setQuiz(quizQuesitionAndAnswer);
  }, []);

  //  console.log("quizData", quizData);

  const target = useRef([]);
  const handleChange = (e, i, x, val = null, qtype = "radio") => {
    const target = e.target;
    // console.log({ e, i, x, val });

    //   setGender(target.value);
    let newData = quizData.map((qd, index) => {
      if (index === i) {
        qd.questionType === "radio" ? (qd.selected = x) : (qd.textValue = val);
      }
      return qd;
    });

    // console.log({ newData });

    // console.log("newData", newData, quizQuesitionAndAnswer)

    setQuiz(newData);
  };

  const calcutate = () => {
    let setValid = [];
    let result = [];

    quizData.map((res, ri) => {
      //   console.log("res", res.selected, res.textValue);
      if (
        res.selected !== null ||
        (res.textValue !== null && res.textValue !== "")
      ) {
        result.push(
          res.selected !== null ? res.quizAnswers[res.selected].choiceValue : 0
        );
        setValid.push(true);
      } else {
        setValid.push(false);
      }
    });

    // console.log("result", result, setValid, quizData);

    if (setValid.every((element) => element === true)) {
      let sum = result.reduce((a, b) => a + b);
      //  console.log({ sum });
      const data = quizResult.filter((qr, qi) => {
        let from = qr.scoreFrom ? qr.scoreFrom : 0;
        let to = qr.scoreTo ? qr.scoreTo : 0;
        //    console.log(from, to);
        if (sum >= from && sum <= to) {
          return qr;
        }
      });
      //    console.log("data", data);
      setResultData([{ ...data[0], sum }]);

      //  console.log("newData", quizData, quizQuesitionAndAnswer);
      setResultShow(true);
    } else {
      alert("all fields required");
    }
  };
  // console.log({ disclaimer });
  function ResultModal(props) {
    const [showThankYou, setShowThankYou] = useState(false);
    const [registerCheck, setRegisterCheck] = useState(false);
    const [loading, setLoading] = useState(false);
    // console.log("ResultData", ResultData);

    const required = <span style={{ color: "red" }}>*</span>;
    return (
      <Modal
        {...props}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {"Result"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {showThankYou ? (
              <div className="thankyou-section" id="modal__thankyou">
                <div className="container-wrapper">
                  <div className="thankyou-content">
                    <StaticImage
                      src="../assets/images/accept.png"
                      className="thankyou-img"
                    />
                    <h1>Thank you For contacting Us</h1>
                    <h1 className="mb-3">We will Get back to you Soon</h1>
                    <Link to="/" className="modal__link">
                      Go back to HBOC
                    </Link>
                  </div>
                </div>
              </div>
            ) : ResultData.length ? (
              <div className="modal_container">
                {/* <div
                className="score"
                style={{
                  color: ResultData[0].color,
                }}
              >
                {ResultData[0].sum}
              </div> */}
                <div
                  className="score"
                  style={{
                    color: ResultData[0].color,
                  }}
                >
                  {ResultData[0].result}
                </div>
                <div
                  className="result"
                  dangerouslySetInnerHTML={{
                    __html: ResultData[0].description,
                  }}
                ></div>
                <Formik
                  initialValues={{
                    email: "",
                  }}
                  validationSchema={yup.object({
                    email: yup.string().email().required("Email is required"),
                  })}
                  onSubmit={async (values, formik) => {
                    //   console.log(values);
                    setLoading(true);
                    try {
                      const formdata = new FormData();
                      // formdata.append("username", values.username);
                      formdata.append("email", values.email);
                      formdata.append("score", ResultData[0].sum);
                      const res = await axios.post(
                        "https://diagnostics.strandls.com/genetic-test-for-hboc-cancer/backend/calculator.php",
                        formdata,
                        {
                          headers: {
                            Authorization:
                              "AIzaSyAVbOssfuND603UkDvvl5koAGxr3oA9WE8",
                          },
                        }
                      );
                      if (res.status === 200) {
                        setShowThankYou(true);
                        setLoading(false);
                      }
                    } catch (error) {
                      setLoading(false);
                      alert("Form submission failed");
                      console.log("error");
                    }
                  }}
                >
                  {(formik) => {
                    return (
                      <>
                        <div
                          className="modal_container__form"
                          style={{ marginBottom: "30px" }}
                        >
                          <div className="registration_title">
                            <input
                              type={"checkbox"}
                              value={registerCheck}
                              checked={registerCheck}
                              onChange={(e) => {
                                //    console.log("check", e.target.checked);
                                setRegisterCheck(e.target.checked);
                              }}
                              className="quiz_check"
                            />
                            <div>
                              <p>
                                {" "}
                                Get the registration link for an exclusive
                                webinar on Genetics and Breast Cancer , by a
                                senior geneticist of Strand Lifesciences.
                              </p>
                              <p className="registration_title">
                                Limited Seats only.
                              </p>
                            </div>
                          </div>
                          <div
                            className="d-flex w-100 flex-column p-2"
                            id="register"
                          >
                            {/* <label htmlFor="username mt-2">
                              Name {required}
                            </label>
                            <input
                              type="text"
                              name="username"
                              id="username"
                              className="form-control"
                              onChange={formik.handleChange("username")}
                            />
                            {formik.touched.username &&
                            formik.errors.username ? (
                              <div className="err">
                                {formik.errors.username}
                              </div>
                            ) : null} */}

                            <label htmlFor="email" className="mt-2">
                              Email {required}
                            </label>
                            <input
                              type="email"
                              name=""
                              id=""
                              className="form-control"
                              onChange={formik.handleChange("email")}
                            />
                            {formik.touched.email && formik.errors.email ? (
                              <div className="err">{formik.errors.email}</div>
                            ) : null}

                            <button
                              type="submit"
                              className="btn btn-primary btn-md mt-4"
                              onClick={formik.handleSubmit}
                              disabled={
                                loading ||
                                (formik.values.email === "" && !registerCheck)
                              }
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </>
                    );
                  }}
                </Formik>
              </div>
            ) : null}
            {/* {} */}
          </>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer> */}
      </Modal>
    );
  }

  //  console.log({ quizResult });
  return (
    <div className="quiz__section" id="Quiz">
      <ResultModal show={showResult} onHide={() => setResultShow(false)} />
      <div className="quiz__header">
        <div className="container-wrapper quiz__headersection">
          <div className="quiz__headertext">
            <h3 className="headerText__small"></h3>
            <h1 className="headerText__big">Breast Cancer Risk Assessment</h1>
            {/* <h1 className="headerText__big">Breast Cancer Risk Calculator</h1> */}
          </div>
        </div>
      </div>
      <div className="quiz_content">
        {quizData.map((qd, i) => {
          return (
            <div key={i}>
              <div className="quiz_question">
                <span>
                  {i + 1} {")"}{" "}
                </span>
                {qd.quizQuestion}
              </div>
              <div className="quiz-answer--wrapper">
                {qd.questionType === "radio" ? (
                  qd.quizAnswers.map((qa, x) => {
                    return (
                      <>
                        <div className="choices">
                          <input
                            type="radio"
                            id={qd.question}
                            name={qd.question}
                            value={qa.choiceValue}
                            checked={qd.selected === x ? true : false}
                            onChange={(e) => {
                              handleChange(e, i, x);
                            }}
                            className="quiz_radio"
                          />
                          <p>{qa.choice}</p>

                          <span
                            className="toolti-wrapper"
                            ref={(el) => (target.current[`${i}${x}`] = el)}
                            onClick={() => {
                              setShow({
                                qi: i,
                                ai: x,
                                show:
                                  show.qi === i && show.ai === x
                                    ? !show.show
                                    : true,
                              });
                            }}
                            style={{
                              display: qa.toolTip ? "inline-flex" : "none",
                            }}
                          >
                            <BsInfoCircleFill size={18} color="#2E598E" />
                          </span>
                          <Overlay
                            target={target.current[`${i}${x}`]}
                            show={show.qi === i && show.ai === x && show.show}
                            transition
                            placement="bottom"
                            rootClose={true}
                            onHide={() => {
                              //     console.log("hided");
                              setShow({
                                qi: null,
                                ai: null,
                                show: false,
                              });
                            }}
                          >
                            {({
                              placement,
                              arrowProps,
                              show: _show,
                              popper,
                              ...props
                            }) => (
                              <div
                                {...props}
                                style={{
                                  position: "absolute",
                                  backgroundColor: "#000000",
                                  padding: "5px 5px",
                                  color: "white",
                                  borderRadius: 3,
                                  ...props.style,
                                  zIndex: 5,
                                  width: "400px",
                                  top: 5,
                                }}
                              >
                                {qa.toolTip}
                              </div>
                            )}
                          </Overlay>
                        </div>
                      </>
                    );
                  })
                ) : (
                  <>
                    <input
                      type="text"
                      className="form-control mt-2"
                      name={qd.quizQuestion}
                      id={qd.quizQuestion}
                      //   value={qd.textValue}
                      onKeyDown={(e) => {
                        let val = e.target.value.trim();
                        handleChange(e, i, null, val, qd.questionType);
                      }}
                      required
                    />
                  </>
                )}
              </div>
            </div>
          );
        })}
        <div className="submit__btn">
          <button className="btn btn-lg btn-success" onClick={calcutate}>
            Calculate
          </button>
        </div>
        <div className="disclaimer">
          <h3>Disclaimer :</h3>
          <div
            className="disc_para"
            dangerouslySetInnerHTML={{
              __html: disclaimer,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Quiz;
